// The notice shown on the door after the client's 401 event fired while a
// session was open (client.ts emits "aleph:session-expired"). Rendered above
// the sign-in actions; the door itself is the recovery.
import { HonestState } from '../../states/HonestState';

export function SessionExpired({ onDismiss }: { readonly onDismiss: () => void }) {
  return (
    <div className="door-hs">
      <HonestState
        variant="Authentication required"
        title="Your session ended"
        reason="The workspace answered 401 to a request. The session cookie is no longer valid: expired, revoked, or signed out elsewhere. Nothing you were viewing was changed."
        nextAction={[{ label: 'Sign in again', onSelect: onDismiss }]}
      />
    </div>
  );
}
